<template>
  <el-card>
    <el-row type="flex" justify="center">
      <h1>Estamos Trabajando</h1>
    </el-row>
    <el-row type="flex" justify="center">
      <el-image :src="src"></el-image>
    </el-row>
  </el-card>
</template>

<script>
import image from "@/assets/images/UnderConstruction.png";
export default {
  name: "Passives",
  data() {
    return {
      src: image
    };
  }
};
</script>

<style></style>
